import { HttpClient } from '../interceptor';

export class CourseManagementApi{
    // 获取课程列表
    static getCourseList = (param) => {
        return new Promise(resolve => {
            HttpClient.post('/api/courseController/queryCourseToB', param).then(res => {
                if(res.data.status === 200){
                    res.data.content.data.forEach(element => {
                        element.price = "¥" + element.price / 100;
                    });
                    resolve(res.data.content);
                }
            }).catch(err => console.log(err));
        })
    }

    // 新增课程
    static insertCourse = (param) => {
        return new Promise(resolve => {
            HttpClient.post('/api/courseController/addCourse', param).then(res => {
                resolve(res);
            }).catch(err => console.log(err));
        })
    }

    // 更新课程
    static updateCourse = (param) => {
        return new Promise(resolve => {
            HttpClient.post('/api/courseController/updateCoursBase', param).then(res => {
                resolve(res);
            }).catch(err => console.log(err));
        })
    }
    // // 编辑门店
    // static updateClassroomCard = (param) => {
    //     return new Promise(resolve => {
    //         HttpClient.post('/api/numberCardController/updateNumberCardToB', param).then(res => {
    //             resolve(res);
    //         }).catch(err => console.log(err));
    //     })
    // }
}